import React from 'react';
import { Mail, Phone, ShoppingCart, Ticket, Database } from 'lucide-react';
export function Services() {
  const services = [{
    icon: Mail,
    title: 'Email & Live Chat Support',
    description: 'Real-time assistance and timely email responses to keep your customers happy and engaged.',
    color: 'blue'
  }, {
    icon: Phone,
    title: 'Phone & Inbound Call Support',
    description: 'Professional voice support handling inquiries, orders, and technical issues with empathy.',
    color: 'indigo'
  }, {
    icon: ShoppingCart,
    title: 'eCommerce Customer Support',
    description: 'Specialized support for online stores including order tracking, returns, and product questions.',
    color: 'emerald'
  }, {
    icon: Ticket,
    title: 'Helpdesk & Ticket Management',
    description: 'Efficient organization and resolution of support tickets using your preferred helpdesk software.',
    color: 'orange'
  }, {
    icon: Database,
    title: 'Back-Office & CRM Support',
    description: 'Data entry, CRM management, and administrative tasks to streamline your operations.',
    color: 'purple'
  }];
  return <section id="services" className="py-20 bg-slate-50" data-id="element-170">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="mb-16" data-id="element-172">
          <span className="text-blue-600 font-semibold tracking-wide uppercase text-sm" data-id="element-173">
            Our Services
          </span>
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-174">
            Comprehensive Support Solutions
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-2xl" data-id="element-175">
            We offer a full suite of BPO services designed to handle every
            aspect of your customer interaction lifecycle.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          {services.map((service, index) => <div key={index} className="group bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 hover:-translate-y-1" data-id="element-177">
              <div className={`h-12 w-12 rounded-lg flex items-center justify-center mb-6 transition-colors duration-300 ${index % 2 === 0 ? 'bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white' : 'bg-slate-50 text-slate-700 group-hover:bg-slate-800 group-hover:text-white'}`} data-id="element-178">
                <service.icon className="h-6 w-6" data-id="element-179" />
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-180">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-181">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}